module.exports = __webpack_public_path__ + "img/medical-operations.cc72aa1a.svg";